import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { axiosFetch } from "../../../utils/AxiosFetch";
import { useNavigate } from 'react-router';
import { Avatar, CircularProgress, Card, Skeleton, Stack, CardActionArea, CardContent, TextField, InputAdornment, Dialog, DialogTitle, DialogContent, DialogActions, TableContainer, Table, TableHead, TableRow, TableBody, TableCell, LinearProgress, useScrollTrigger, Chip, Alert, Popover } from '@mui/material';
import { useDispatch } from 'react-redux';
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import { training_list } from '../../../redux/actions/training.action';
import CancelIcon from '@mui/icons-material/Cancel';
import * as XLSX from 'xlsx';
import { TimeConversion } from '../../../utils/TimeConversion';
import Dropzone from 'react-dropzone';
import { UploadFile } from '@mui/icons-material';
import { configAxios } from '../../../utils/ConfigAxios';
import sampleFile from '../../../assets/samplefile.xlsx';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '1px solid #f8f8f8',
    borderRadius: "5px",
    p: 2,
    width: '800px'
};

function AttendeesModal(props) {

    var remark;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const [memberList, setMemberLit] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [comment, setComment] = React.useState("");
    const [childOpen, setChildOpen] = React.useState(false)


    const columns = [
        { id: 'Employee ID', label: 'Emp ID',minWidth: 100, maxHeight: 100 },
        { id: 'name', label: 'Name', minWidth: 100, maxHeight: 100  },
        {
            id: 'email',
            label: 'Email Address',
            minWidth: 170,
            align: 'left',
            maxHeight: 100
          
        },
        {
            id: 'phone',
            label: 'Phone Number',
            minWidth: 170,
            align: 'left',
            maxHeight: 100
           
        },
        {
            id: 'department',
            label: 'Department Name',
            minWidth: 170,
            align: 'left',
            maxHeight: 100
            
        },
        {
            id: 'team',
            label: 'Team Name',
            minWidth: 170,
            align: 'left',
            maxHeight: 100
            
        },
        {
            id: 'designation',
            label: 'Designation',
            minWidth: 170,
            align: 'left',
            maxHeight: 100
           
        },
        {
            id: 'comment',
            label: 'Trainer Comment',
            maxWidth: 170,
            align: 'left',
            maxHeight: 10
           
        },
    ];

    const handleClose = () => {
        props.handleAttendees();
        setMemberLit([])
        setOpen(false);
    }
    React.useEffect(() => {
        if (props.open) {
            setOpen(true)
            setLoading(false)
            if (props.open === true && props.id !== 0) {
                handleList(props.type, props.id)
            }
        }
        console.log(props)
    }, [props])

    const handleList = (type, trainingId) => {
        axiosFetch({
            url: `/Training/${type}/${trainingId}`,
            method: "get",
        })
            .then((res) => {
                if (res.status === 200) {
                    setMemberLit(res.data)
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const handleView = (id) => {
        navigate(`/users-profile/${id}`);
    }
    const handleUnroll = (id) => {
        var req = {
            "userId": id,
            "id": props.id
        }
        axiosFetch({
            url: `/Training/unroll`,
            method: "post",
            requestConfig: req
        })
            .then((res) => {
                if (res.status === 200) {
                    var req = {
                        "page": 1,
                        "resultsPerPage": 6,
                        "title": "",
                        "year": "",
                    }
                    handleClose()
                    dispatch(SnackbarActions(true, "success", `Training has been unrolled Successfully `))
                    dispatch(training_list(req))

                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const handleCancel = (id) => {
        document.getElementById(id).value = "";
    }
    const handleTrainingManComment = () => {
        var comment = [];
        var objects;
        memberList.map((member) => {
            if (document.getElementById(member.id).value !== "") {
                objects = {
                    "comment": document.getElementById(member.id).value,
                    "userId": member.id,
                }
                comment.push(objects)
            }

        })
        var req = {
            "id": props.id,
            "comments": comment
        }
        console.log(req)
        setLoading(true)
        axiosFetch({
            url: `Training/trainer/comment`,
            method: "post",
            requestConfig: req
        })
            .then((res) => {
                if (res.status === 200) {
                    setLoading(false)
                    dispatch(SnackbarActions(true, "success", "Your comments are added "))
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const handleCommentChange = (e, member) => {
        //  var member = memberList.filter(member =>
        //      e.target.id === member.id);
        //     console.log(member)
    }

    const exportData = () => {
        const result = memberList.map(({ id, departmentCode, image, ...rest }) => {
            return rest;
        });



        let date = TimeConversion(props.trainingStartDate, 0);
        let title = props.trainingTitle + "_" + date;

        let header = ["Employee Code", "First Name", "Last Name", "Email Address", "Phone Number", "Department Name", "Team Name", "Designation", "Trainer Comment"];
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.sheet_add_json(ws, result, { origin: 'A2', skipHeader: true });
        XLSX.utils.sheet_add_aoa(ws, [header]);
        XLSX.utils.book_append_sheet(wb, ws, "DownloadData");
        XLSX.writeFileXLSX(wb, `${title}.xlsx`);
    }

    const handleChildModal = () => {
        if (childOpen) {
            setChildOpen(false)
        }
        else {
            setChildOpen(true)
        }
    }

    return (
        <div>
            <Dialog
                fullWidth="md"
                maxWidth="md"
                open={open}
                onClose={handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{ height: "680px" }}
            >
                <DialogTitle id="scroll-dialog-title">
                    <Typography id="modal-modal-title" sx={{ borderBottom: "1px solid #ccc", paddingBottom: "10px", marginBottom: "30px" }} className='modal-heading' variant="h6" component="h2">
                        {props.type === "attendees" ? `${props.trainingTitle} Attendees List` : `${props.trainingTitle} Interested people`}
                        {/* {props.type === "attendees" ? <Button className='theme-btn' variant='contained' onClick={() => exportData()}>Download</Button> : ""} */}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box>


                        {memberList.length > 0 ?
                            memberList.map((member) => {
                                remark = member.trainerComment;
                                return (

                                    <Box sx={{
                                        display: 'flex', flexDirection: 'row',
                                        '& .MuiTextField-root': { m: 1, width: '35ch' }
                                    }}>
                                        {props.status === "Completed" ? <></> :
                                            <Card sx={{ margin: 1, marginBottom: "15px", p: 1, width: props.status === "Completed" ? "450px" : "650px" }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                    <Avatar
                                                        src={`/api/uploads/image/show/${member.image}`}
                                                        alt={member.firstName.toUpperCase()}
                                                        sx={{ height: 40, width: 40 }} />
                                                    <CardContent sx={{ flex: '1 0 auto' }}>
                                                        <CardActionArea onClick={() => handleView(member.id)}>
                                                            <Typography component="div" variant="h5">
                                                                {member.firstName + " " + " " + member.lastName}
                                                            </Typography>
                                                            <Typography variant="subtitle1" color="text.secondary" component="div">
                                                                {member.jobTitle !== null ? member.jobTitle : "CEO"}
                                                            </Typography>
                                                        </CardActionArea>
                                                    </CardContent>
                                                    <CardContent>
                                                        <Button className='theme-btn' variant="outlined" onClick={() => handleUnroll(member.id)}>unroll</Button>
                                                    </CardContent>
                                                </Box>

                                            </Card>}

                                    </Box>

                                )

                            })
                            :
                            <Stack spacing={2}>
                                <Skeleton animation="wave" variant="rounded" width={450} height={40} />
                                <Skeleton animation="wave" variant="rounded" width={450} height={40} />
                                <Skeleton animation="wave" variant="rounded" width={450} height={40} />
                            </Stack>
                        }
                        {props.status === "Completed" && memberList.length > 0  ?
                            <TableContainer sx={{ maxHeight: 440 }} className='single-list-bg' >
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow className='single-bg'>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth, maxHeight: column.maxHeight }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody  >
                                        {memberList
                                            .map((member) => {
                                                return (
                                                    <TableRow hover role="checkbox" tabIndex={-1} className='single-even'  >

                                                        <TableCell className='pop-id'>
                                                            {member.employeeCode}
                                                        </TableCell>
                                                        <TableCell className='pop-name'>
                                                            {member.firstName + " " + member.lastName}
                                                        </TableCell>
                                                        <TableCell className='pop-email'>
                                                            {member.email}
                                                        </TableCell>
                                                        <TableCell className='pop-phone'>
                                                            {member.phone ? member.phone : "-"}
                                                        </TableCell>
                                                        <TableCell className='pop-dept'>
                                                            {member.department ? member.department : "-"}
                                                        </TableCell>
                                                        <TableCell className='pop-team-name'>
                                                            {member.team ? member.team : "-"}
                                                        </TableCell>
                                                        <TableCell className='pop-title'>
                                                            {member.jobTitle ? member.jobTitle : "-"}
                                                        </TableCell>
                                                        <TableCell className='pop-trainer-commt'>
                                                            <div className='text-over'> {member.trainerComment ? member.trainerComment : "-"}</div>
                                                        </TableCell>

                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            : ""}
                        <ChildDialog open={childOpen} handleOpen={handleChildModal} id={props.id} />
                    </Box>
                </DialogContent>
                <DialogActions>
                <Button className='theme-btn all-down' variant='contained' onClick={() => exportData()}>Download</Button>

                    {props.status === "Completed" ?
                        // props.type === "attendees" ?
                        <>
                            <Button className='theme-btn' variant='contained' onClick={() => setChildOpen(true)}>Upload</Button>
                        </>
                            // : ""
                        // loading ? <CircularProgress sx={{ float: "right", marginRight: 1 }} fontSize="small" /> :
                        //     <Button className='theme-btn' variant="outlined" sx={{ float: "right", marginRight: 1 }} onClick={() => handleTrainingManComment()}>save</Button>
                        : ""}
                </DialogActions>

            </Dialog>

        </div>
    )
}
export default AttendeesModal;

function ChildDialog(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(props.open);
    const [loading, setLoading] = React.useState(false);
    const [isFile, setIsFile] = React.useState(false);
    const [actualFileName, setActualFileName] = React.useState("");
    const [physicalFileName, setPhysicalFileName] = React.useState("");
    const [btnLoader,setBtnLoader] = React.useState(false);

    const handleClose = () => {
        props.handleOpen();
        setOpen(false);
        handleRemove()
    };

    React.useEffect(() => {
        if (props.open) {
            setOpen(true)
        }
    }, [props])

    const onDrop = (file) => {
        console.log((file[0].size) / 1048576)
        const fileSize = (file[0].size) / 1048576
        const roundOff = Math.floor(fileSize)
        if (roundOff < 31) {
            var fileName = file[0].name
            var accept = fileName.split(".").pop();
            // console.log(fileName)
            if (accept === "xlsx" || accept === "xls") {
                setLoading(true)
                const formData = new FormData();
                formData.append("file", file[0], file[0].name);
                console.log(formData)
                configAxios
                    .post("/Uploads/training/file", formData)
                    .then((res) => {
                        if (res.status === 200) {
                            setLoading(false)
                            setActualFileName(res.data[0].actualFileName);
                            setPhysicalFileName(res.data[0].physicalFileName);
                            setIsFile(true)
                        }
                    })
                    .catch((error) => {
                        setLoading(false)
                        if (error.response.status === 400) {
                            dispatch(SnackbarActions(true, "error", "Something went wrong"))

                        }
                    });
            }
            else {
                dispatch(SnackbarActions(true, "warning", "Uploading file type is not accepted"))

            }
        }
        else {
            dispatch(SnackbarActions(true, "warning", "File Size limit upto 30mb"))
        }

    }

    const handleRemove = () => {
        setIsFile(false)
        setActualFileName("");
        setPhysicalFileName("");
    }

    const handleUpload = () => {
        console.log(props.id)
        if (physicalFileName !== "") {
            var req = {
                "id": props.id,
                "fileName": physicalFileName
            }
            console.log(req);
            setBtnLoader(true);
            axiosFetch({
                url: `Training/trainer/comment`,
                method: "post",
                requestConfig: req
            })
                .then((res) => {
                    if (res.status === 200) {
                        dispatch(SnackbarActions(true, "success", "Your file uploaded successfully "));
                        setBtnLoader(false);
                        handleClose();
                    }
                    else if (res.status === 400) {
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                        setBtnLoader(false);
                    }
                    if (res.status === 401) {
                        navigate("/");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    return (
        <React.Fragment>
            {/* <Button onClick={handleOpen}>Open Child Modal</Button> */}
            <Modal
                // hideBackdrop
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{ ...style, width: 500 }}>
                    <h2 id="child-modal-title">Upload File</h2>
                    <Alert severity='error'>Accepted file types : <em> xls, xlsx</em>
                        <br />
                        Max file size 30MB
                    </Alert>
                    <br />
                    <Dropzone
                        disableClick={true}
                        onDrop={onDrop}
                        className="dropzone"
                        activeClassName="active-dropzone"
                        minSize={0}
                    //   maxSize={5242880}
                    >
                        {({ getRootProps, getInputProps }) => {
                            return (
                                <section>
                                    {isFile ?
                                        <p>
                                            <Chip label={actualFileName} onDelete={handleRemove} />

                                        </p> :
                                        <div
                                            {...getRootProps()}
                                            style={{
                                                cursor: "pointer",
                                                border: "1px solid grey",
                                                borderRadius: "10px",
                                                textAlign: "center"
                                            }}
                                        >
                                            <input
                                                {...getInputProps()}
                                            />
                                            <p>
                                                Drag file here
                                                <br />-- OR --
                                                <br />
                                                <UploadFile />Upload from Computer
                                            </p>
                                            {loading ? <LinearProgress sx={{ borderRadius: 4, height: 7 }} /> : ""}

                                        </div>}

                                </section>
                            )
                        }}
                    </Dropzone>
                    {isFile ? "" :
                        <p id="child-modal-description">
                            <PopupState variant="popover" popupId="demo-popup-popover">
                                {(popupState) => (
                                    <div>
                                        <p style={{cursor:"pointer",textDecoration:"underline"}} {...bindTrigger(popupState)}>
                                           Click here for Column Names in excel sheet
                                        </p>
                                        <Popover
                                            {...bindPopover(popupState)}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'center',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                        >
                                            <Typography sx={{ p: 2 }}>
                                                Employee Code <br />
                                                First Name<br />
                                                Last Name<br />
                                                Email Address<br />
                                                Phone Number<br />
                                                Department Name <br />
                                                Team Name<br />
                                                Designation <br />
                                                Trainer Comment

                                            </Typography>
                                        </Popover>
                                    </div>
                                )}
                            </PopupState>

                            <a href={sampleFile} download="samplefile">click here to download template file</a>
                        </p>}
                    {btnLoader?"":<Button variant="outlined" className="theme-btn cancel-btn" onClick={handleClose}>Close</Button>}
                    {btnLoader?
                    <CircularProgress fontSize="small" sx={{float:"right"}}/>:
                    <Button className='theme-btn' sx={{ marginRight: 1 }} onClick={() => handleUpload()}>upload</Button>}

                </Box>

            </Modal>
        </React.Fragment>
    );
}